/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */ // Translation keys use snake_case

import { RawTranslations } from '@repo/types';

const translations: RawTranslations = {
    // Native membership
    choose_another_card: 'Valitse toinen kortti',
    use_auto_selection: 'Käytä automaattista valintaa',
    split_into_groups: 'Jaa ryhmiin',
    add_group: 'Lisää ryhmä',
    merge_back_to_auto: 'Yhdistä takaisin automaattiseen',
    remove_group: 'Poista ryhmä',
    cards: 'korttia',
    tickets: 'lippua',
    remaining_on_auto: 'Loput katetaan automaattisesti',
    member_card_not_applicable: 'Ei sovellettavissa',
    group_label: 'Ryhmä',
    have_account_or_member_card: 'Onko sinulla tili tai jäsenkortti?',
    member_card_coverage_failed: 'Jäsenkorttejasi ei voitu käyttää.',
    retry: 'Yritä uudelleen',
    your_member_cards: 'Jäsenkorttisi',
    pay_with_money_instead: 'Maksa rahalla',
    member_card_purchased: 'Osto valmis',
    start_date: 'Aloituspäivä',
    my_page: 'Oma sivu',
    password: 'Salasana',
    forgot_password: 'Unohditko salasanan?',
    member_login_subtitle: 'Kirjaudu jäsentilillesi',
    member_signup_subtitle: 'Luo jäsentilisi',
    register: 'Rekisteröidy',
    create_account: 'Luo tili',
    become_member: 'Liity jäseneksi',
    confirm_password: 'Vahvista salasana',
    need_help: 'Tarvitsetko apua?',
    and: 'ja',
    passwords_do_not_match: 'Salasanat eivät täsmää',
    password_too_short: 'Salasanan on oltava vähintään 8 merkkiä',
    invalid_phone_format: 'Anna kelvollinen puhelinnumero (esim. +4791234567)',
    email_already_registered: 'Tämä sähköpostiosoite on jo rekisteröity',
    registration_failed: 'Rekisteröinti epäonnistui. Yritä uudelleen.',
    forgot_password_email_sent:
        'Jos sähköpostiosoite on rekisteröity, lähetämme sinulle pian palautuslinkin.',
    wrong_email_or_password: 'Väärä sähköposti tai salasana',
    member_session_expired: 'Istuntosi on vanhentunut. Kirjaudu sisään uudelleen.',
    show_password: 'Näytä salasana',
    hide_password: 'Piilota salasana',
    show_cancellation_policy: 'Näytä peruutusehdot',
    hide_cancellation_policy: 'Piilota peruutusehdot',
    departure: 'Lähtö',
    price: 'Hinta',
    difficulty: 'Vaikeustaso',
    duration: 'Kesto',
    starting_time: 'Aloitusaika',
    about: 'Tietoa',
    book_now: 'Varaa nyt',
    book: 'Varaa',
    buy_as_gift: 'Osta lahjaksi',
    from: 'Alkaen',
    your_booking_reference_is: 'Varausnumero on',
    booking_details_in_email: 'Saat pian sähköpostitse lisätietoja',
    see_more_activities: 'Katso lisää aktiviteetteja',
    your_cart: 'Ostoskori',
    in_your_cart: 'Ostoskorissasi',
    when_are_you_going: 'Valitse päivämäärä ja aika',
    how_many_are_going: 'Montako lähtee?',
    contact_details: 'Yhteystiedot',
    traveler: 'Matkustaja',
    extras: 'Lisäpalvelut',
    please_select: 'Valitse',
    no_items_in_cart: 'Ostoskori on tyhjä',
    payment: 'Maksu',
    receipt: 'Kuitti',
    do_you_have_any_comments_or_special_needs: 'Onko sinulla kommentteja tai erityistarpeita?',
    i_have_read_and_accepted_the: 'Olen lukenut ja hyväksyn',
    privacy_policy: 'Tietosuojakäytännön',
    terms_and_conditions: 'Käyttöehdot',
    must_accept_privacy_policy: 'Sinun on hyväksyttävä tietosuojakäytäntö jatkaaksesi',
    must_accept_terms_and_conditions: 'Sinun on hyväksyttävä käyttöehdot jatkaaksesi',
    first_name: 'Etunimi',
    last_name: 'Sukunimi',
    phone_number: 'Puhelinnumero',
    dial_code: 'Maakoodi',
    email: 'Sähköposti',
    is_required: 'on pakollinen',
    please_register: 'Rekisteröidy',
    main_contact: 'Pääyhteyshenkilö',
    additional_information: 'Lisätiedot',
    remove_cart_item: 'Poista tuote',
    excl: 'alv. EI SIS.',
    vat: 'ALV',
    total: 'Yhteensä',
    payNow: 'Maksa nyt',
    payLater: 'Maksa myöhemmin',
    only_deposit_amount_to_pay_now: {
        template: 'Maksa nyt vain <NAME> ennakkoa.',
    } as any,
    next: 'Seuraava',
    go_and_pay: 'Mene maksamaan',
    confirm_booking: 'Vahvista varaus',
    no_payment_required: 'Maksua ei vaadita',
    print: 'Tulosta',
    close: 'Sulje',
    checkout: 'Kassa',
    summary: 'Yhteenveto',
    cancel: 'Peruuta',
    save: 'Tallenna',
    select_time: 'Valitse aika',
    selected_time: 'Valittu aika',
    time: 'Aika',
    go_back: 'Palaa takaisin',
    thank_you_for_booking_with_us: 'Kiitos varauksestasi!',
    please_fill_in_all_required_information: 'Täytä kaikki pakolliset tiedot',
    error_occurred_when_creating_reservation: 'Virhe varauksen luonnissa',
    error_occurred_when_creating_giftcard: 'Virhe lahjakortin luomisessa',
    couldnt_apply_promocode_is_the_code_correct: 'Promokoodia ei voitu käyttää. Onko koodi oikein?',
    choose_a_country: 'Valitse maa',
    select_date: 'Valitse päivämäärä',
    select_travelers: 'Valitse matkustajat',
    hourShort: 'h',
    dayShort: 'pv',
    minuteShort: 'min',
    years: 'vuotta',
    age: 'Ikä',
    more_information: 'Lisätietoja',
    same_as_main_contact: 'Kuten pääyhteyshenkilö',
    easy: 'Helppo',
    medium: 'Keskitaso',
    hard: 'Vaikea',
    please_select_date: 'Valitse päivämäärä',
    please_select_date_and_time: 'Valitse päivämäärä ja aika',
    name: 'Nimi',
    comment: 'Kommentti',
    submit_request: 'Lähetä pyyntö',
    any_special_requests_etc: 'Erityistoiveita tai ruoka-allergioita?',
    request_tour_comment: 'Kuvaile pyyntösi',
    thank_you_for_your_request: 'Kiitos pyynnöstäsi, palaamme pian.',
    got_it: 'Selvä!',
    continue_shopping: 'Jatka ostoksia',
    continue_travelers: 'Matkustajat',
    please_provide_your_name: 'Anna nimesi',
    please_provide_your_email: 'Anna kelvollinen sähköposti',
    please_provide_a_description: 'Anna kuvaus',
    an_error_occurred_when_submitting_your_request:
        'Virhe pyynnön lähettämisessä. Yritä myöhemmin uudelleen.',
    private_tour: 'Yksityiskierros',
    read_more_and_book: 'Lue lisää & varaa',
    read_more: 'Lue lisää',
    prices_from: 'Hinnat alkaen',
    about_the_trip: 'Tietoa matkasta',
    prices: 'Hinnat',
    whats_included: 'Sisältää',
    any: 'Mikä tahansa',
    duration_up_to_1_hour: 'Enintään 1 tunti',
    duration_1_2_hours: '1–2 tuntia',
    duration_2_6_hours: '2–6 tuntia',
    duration_6_12_hours: '6–12 tuntia',
    duration_12_24_hours: '12–24 tuntia',
    duration_1_2_days: '1–2 päivää',
    duration_more_than_2_days: 'Yli 2 päivää',
    find_activities: 'Etsi aktiviteetteja',
    ok: 'OK',
    clear: 'Tyhjennä',
    filterActivities: 'Suodata aktiviteetteja',
    hideFilters: 'Piilota suodattimet',
    shopMore: 'Osta lisää',
    noSearchResults: 'Valitettavasti ei löytynyt aktiviteetteja hakuehdoilla.',
    update: 'Päivitä',
    select_date_to_view_timeslots: 'Valitse päivä nähdäksesi ajat',
    your_reservation_timed_out: 'Varauksesi aikakatkaistiin. Yritä uudelleen.',
    aria_calendar_input_field_label: 'Kalenteri, paina Enter avataksesi.',
    aria_book_now_button: 'Avaa varausikkuna tälle aktiviteetille',
    aria_next_image: 'Seuraava kuva',
    aria_previous_image: 'Edellinen kuva',
    aria_open_booking_widget: 'Avaa varausikkuna',
    aria_close_booking_widget: 'Sulje varausikkuna',
    aria_go_to_home: 'Siirry etusivulle',
    aria_checkout_steps: 'Kassan vaiheet',
    aria_order_summary: 'Tilauksen yhteenveto',
    expanded: 'laajennettu',
    collapsed: 'tiivistetty',
    aria_open_request_tour_widget: 'Avaa tapahtumapyyntöikkuna',
    aria_close_request_tour_widget: 'Sulje tapahtumapyyntöikkuna',
    aria_open_find_activity: 'Avaa aktiviteettien haku',
    aria_close_find_activity: 'Sulje aktiviteettien haku',
    aria_show_giftcard_input: 'Näytä lahjakenttä',
    aria_hide_giftcard_input: 'Piilota lahjakenttä',
    fill_giftcard_code: 'Anna lahjakorttikoodi',
    aria_show_promocode_input: 'Näytä promokenttä',
    aria_hide_promocode_input: 'Piilota promokenttä',
    aria_price_to_pay_summary: 'Yhteenveto maksettavasta hinnasta',
    vat_breakdown: 'ALV-erittely',
    fill_promocode: 'Anna promokoodi',
    request_tour: 'pyydä kierrosta',
    giftcard_message: 'viesti',
    giftcard_message_label: 'henkilökohtainen viesti (valinnainen)',
    recipient_details: 'Saajan tiedot',
    gift_card: 'Lahjakortti',
    value: 'Arvo',
    create: 'Luo',
    create_your_gift: 'Luo lahjakorttisi',
    your_giftcard_reference_is: 'Lahjakorttisi viite on',
    giftcard_voucher_and_receipt: 'Lähetimme sinulle lahjakortin ja kuitin:',
    giftcard_voucher: 'Lähetimme lahjakortin:',
    giftcard_and_receipt: 'ja kuitin sinulle:',
    thank_you_for_your_purchase: 'Kiitos ostostasi!',
    valid_until: 'Voimassa asti',
    print_receipt: 'Tulosta kuitti',
    select_gift_type: 'Valitse lahjan tyyppi',
    please_select_gift_type: 'Valitse lahjan tyyppi',
    select_gift_print_description: 'Saat tulostettavan lahjakortin sähköpostiin',
    select_gift_email_description: 'Lähetä lahjakortti suoraan saajalle sähköpostitse',
    enter_giftcard_code: 'Anna lahjakorttikoodi',
    enter_promo_code: 'Anna promokoodi',
    apply: 'Käytä',
    giftcard_code_error: 'Lahjakorttikoodi ei kelpaa',
    remaining_value: 'Jäljellä oleva arvo',
    giftcard_code_not_found: 'Lahjakorttia ei löytynyt koodilla:',
    giftcard_zero_balance: 'Lahjakortti on tyhjä',
    giftcard_is_expired: 'Lahjakortti on vanhentunut',
    purchased_giftcard: {
        self: 'Tulostettava lahjakortti lähetetty sinulle',
        recipient: 'Tulostettava lahjakortti lähetetty saajalle',
    },
    contact_information: {
        short: 'Yhteystiedot',
        long: 'Yhteystiedot',
    },
    minutes: {
        singular: 'min',
        plural: 'min',
        long: 'minuutti',
    },
    hours: {
        singular: 'h',
        plural: 'h',
    },
    days: {
        singular: 'pv',
        plural: 'pv',
    },
    children: {
        singular: 'lapsi',
        plural: 'lapset',
    },
    adult: {
        singular: 'aikuinen',
        plural: 'aikuiset',
    },
    card: {
        singular: 'kortti',
        plural: 'kortit',
    },
    too_few_travelers: 'Liian vähän osallistujia',
    too_few_travelers_quantity: {
        template: 'Vähintään <COUNT:ticket:tickets> tarvitaan tänä päivänä',
    } as any,
    number_of_travelers_exceeded: {
        template: 'Enintään <COUNT:ticket:tickets> käytettävissä tänä päivänä',
    } as any,
    booking_is_closed: {
        template: 'Varaus <NAME> on nyt suljettu',
    } as any,
    rooms: {
        singular: 'huone',
        plural: 'huoneet',
    },
    person: {
        singular: 'henkilö',
        plural: 'henkilöt',
    },
    select_room: 'Valitse huone',
    change_room: 'Vaihda huonetta',
    less_than: 'vähemmän kuin',
    year: {
        singular: 'vuosi',
        plural: 'vuotta',
    },
    select_age: 'Valitse ikä',
    done: 'Valmis',
    number_of_rooms: 'Huoneiden määrä',
    select_bed: 'Valitse vuode',
    room_info: 'Huonetiedot',
    price_one_night_one_guest: {
        template: 'hinta <COUNT:night:nights> yötä, <COUNT:guest:guests> vieraalle',
    } as any,
    one_night_one_guest: {
        template: '<COUNT:night:nights> yötä, <COUNT:guest:guests> vierasta',
    } as any,
    price_nights: {
        template: 'hinta <COUNT:night:nights> yölle',
    } as any,
    night: {
        singular: 'yö',
        plural: 'yöt',
    },
    select_room_for_total_price: 'Valitse huoneet nähdäksesi kokonaishinnan',
    find_rooms: 'Etsi huoneita',
    check_in_check_out: 'Sisään/ulos kirjautuminen',
    guest_and_rooms: 'Vieraat ja huoneet',
    no_accommodations_found:
        'Emme valitettavasti löytäneet huoneita hakuehdoillasi. Yritä muuttaa hakuehtoja.',
    facilities_included: 'Palvelut sisältyvät',
    price_per_night: 'Hinta per yö',
    season: 'Sesonki',

    has_airconditioning: 'Ilmastointi',
    has_balcony: 'Parveke',
    has_bicycles: 'Polkupyöriä',
    has_boat: 'Venepaikka',
    has_coffee_maker: 'Kahvinkeitin',
    has_dishwasher: 'Astianpesukone',
    has_dryer: 'Kuivausrumpu',
    has_fireplace: 'Takka',
    has_garage: 'Autotalli',
    has_garden_furniture: 'Puutarhakalusteet',
    has_grill: 'Grilli',
    has_kitchen: 'Keittiö',
    has_minibar: 'Minibaari',
    has_mooring_space: 'Venepaikka',
    has_pool: 'Uima-allas',
    has_roomservice: 'Huonepalvelu',
    has_sauna: 'Sauna',
    has_tv: 'TV',
    has_washing_machine: 'Pesukone',
    has_wifi: 'WiFi',
    is_breakfast_included: 'Aamiainen',
    is_cancellation_included: 'Peruutusmahdollisuus',
    is_pets_allowed: 'Lemmikit sallittu',
    is_smoking_allowed: 'Tupakointi sallittu',
    is_towels_and_bedlines_included: 'Pyyhkeet ja lakanat sisältyvät',
    is_wheelchair_accessible: 'Esteetön',
    wifi: 'WiFi',
    breakfast: 'Aamiainen',
    accessible: 'Esteetön',
    pets: 'Lemmikit',
    kitchen: 'Keittiö',
    smoking: 'Tupakointi',
    unknown: 'Tuntematon',
    accommodation_cancellation_policy: '',
    accommodations: 'Majoitukset',
    activities: 'Aktiviteetit',
    address: 'Osoite',
    city: 'Kaupunki',
    post_code: 'Postinumero',
    to: '–',
    date_range_start: 'alkaen',
    date_range_end: 'päättyen',
    flag_of: 'lippu: ',
    monday: 'maanantai',
    tuesday: 'tiistai',
    wednesday: 'keskiviikko',
    thursday: 'torstai',
    friday: 'perjantai',
    saturday: 'lauantai',
    sunday: 'sunnuntai',
    today: 'tänään',
    tomorrow: 'huomenna',
    january: 'tammikuu',
    february: 'helmikuu',
    march: 'maaliskuu',
    april: 'huhtikuu',
    may: 'toukokuu',
    june: 'kesäkuu',
    july: 'heinäkuu',
    august: 'elokuu',
    september: 'syyskuu',
    october: 'lokakuu',
    november: 'marraskuu',
    december: 'joulukuu',
    few_left: 'vähän jäljellä',
    tickets_left: {
        template: '<COUNT:ticket:tickets> jäljellä',
    } as any,
    available: 'Saatavilla',
    sold_out: 'Loppuunmyyty',
    upcoming_tours_title: 'Tulossa olevat kierrokset',
    unavailable: 'Ei saatavilla',
    notes_regarding_your_stay: 'Huomioita vierailustasi',
    notes_for_accommodation_name_with_guests: {
        template: 'Muistiinpanot: <NAME>, <COUNT:guest:guests> vierasta',
    } as any,
    select_price_type: 'Valitse hintatyyppi',
    tour_option: 'Kierrosvaihtoehto',
    finding_available_rooms: 'Haetaan vapaita huoneita',
    loading_availability: 'Ladataan saatavuutta...',
    total_price: 'Kokonaishinta',
    of: '/',
    select_dates: 'Valitse päivät',
    please_select_price_type: 'Valitse hintatyyppi',
    a_minimum_of_participants_is_required_to_book_this_product:
        'Vähimmäisosallistujamäärä vaaditaan tämän tuotteen varaamiseen.',
    a_minimum_of_x_participants_is_required_to_book_this_product: {
        template: 'Vähintään <COUNT> osallistujaa tarvitaan.',
    } as any,
    aBookingConfirmationWillBeSentToYourEmailAddressAsSoonAsWeHaveProcessedYourOrder:
        'Varausvahvistus lähetetään sähköpostiisi, kun tilaus on käsitelty.',
    aConfirmationWillBeSentToYourEmailAddressAsSoonAsWeHaveProcessedYourOrder:
        'Vahvistus lähetetään sähköpostiisi, kun tilaus on käsitelty.',
    add: 'Lisää',
    amount: 'Määrä',
    areYouAMemberOrHaveValueCard: 'Oletko jäsen tai onko sinulla arvolippu?',
    areYouSureYouWantToCancelYourBooking: 'Haluatko varmasti peruuttaa varauksesi?',
    areYouSureYouWantToCancelYourMembership: 'Haluatko varmasti peruuttaa jäsenyytesi?',
    automaticallyRenewed: 'Uutistuu automaattisesti',
    at: 'Klo',
    backToWebsite: 'Takaisin sivustolle',
    belayCertification: 'Turvaköysivarmennus',
    belayCertificationConsent: 'Minulla on turvaköysivarmennus',
    buyMembership: 'Osta jäsenyys',
    buyNow: 'Osta nyt',
    cancelled: 'Peruttu',
    canBeCancelledFrom: 'Peruutettavissa alkaen',
    choose_payment_method: 'Valitse maksutapa',
    bookNow: 'Osta nyt',
    bookTimeslot: 'Osta liput',
    cancellation: 'Peruutus',
    choose: 'Valitse',
    chooseACountry: 'Valitse maa',
    chooseCreditsType: 'Valitse arvolippu',
    chooseDateAndTime: 'Valitse päivämäärä ja aika',
    chooseNumberOfCredits: 'Valitse arvolippujen määrä',
    chooseStartDate: 'Valitse aloituspäivä',
    chooseType: 'Valitse tyyppi',
    ticketCode: 'Tilausnumero',
    completed: 'Valmis',
    consents: 'Suostumukset',
    contact: 'Yhteys',
    contactByEmail: 'Yhteys sähköpostilla',
    contactBySms: 'Yhteys SMS:llä',
    couldntApplyGiftcardIsTheCodeCorrect: 'Lahjakorttia ei voitu käyttää. Onko koodi oikein?',
    couldntApplyPromocodeIsTheCodeCorrect: 'Promokoodia ei voitu käyttää. Onko koodi oikein?',
    promocodeIsNotCompatibleWithCart:
        'Tämä alennuskoodi ei ole yhteensopiva valitsemiesi tuotteiden kanssa.',
    couldntGetCompanyInformation: 'Yritystietoja ei saatu.',
    couldntGetPaymentPlan: 'Maksusuunnitelmaa ei voitu hakea. Yritä päivittää sivu.',
    couldntGetPaymentPlanUsingPreviousPlan:
        'Maksusuunnitelmaa ei saatu, käytetään aiempaa suunnitelmaa.',
    couldntGetValueCards: 'Arvolippuja ei saatu.',
    couldntGetValueCardProducts: 'Arvolipputuotteita ei saatu.',
    couldntGetProductPleaseTryAgain: 'Tuotetta ei saatu, yritä uudelleen.',
    couldntOpenBookingCheckoutNotAllBookingInformationHasBeenSet:
        'Kassaikkuna ei avautunut. Kaikki tarvittavat tiedot eivät ole paikoillaan.',
    couldntOpenProfilePleaseSignInFirst: 'Profiilia ei voitu avata. Kirjaudu ensin sisään.',
    couldntOpenValueCardCheckoutNotAllValueCardInformationHasBeenSet:
        'Arvolippukassa ei avautunut. Tiedot puuttuvat.',
    country: 'Maa',
    createAccount: 'Luo tili',
    credit: {
        singular: 'Arvo',
        plural: 'Arvot',
    },
    credits: 'Arvot',
    creditsLeft: 'Jäljellä olevat arvot',
    creditDiscount: 'Arvonalennus',
    discount: 'Alennus',
    free: 'Ilmainen',
    date: 'Päivämäärä',
    delete: 'Poista',
    doYouHaveAnAccount: 'Onko sinulla tili?',
    doYouHaveValueCards: 'Onko sinulla arvolippuja tai tili?',
    doYouHaveBrattkort: 'Onko sinulla Brattkort tai turvaköysivarmennus?',
    doYouHaveClimbingCertification: 'Onko sinulla kiipeilysertifikaattia?',
    edit: 'Muokkaa',
    editTimeslot: 'Muokkaa ajankohtaa',
    failed: 'Epäonnistui',
    firstName: 'Etunimi',
    giftcard: 'Lahjakortti',
    goToMyPage: 'Siirry omalle sivulleni',
    ifYouWantToDeleteYourProfile: 'Jos haluat poistaa profiilisi',
    youCanPurchaseBookingsFromTheShopOnThisWebsite: 'Voit ostaa lippuja tältä sivustolta.',
    yourOrderReferenceIs: 'Tilausnumerosi on',
    iHaveReadAndAccepted: 'Olen lukenut ja hyväksyn',
    lastName: 'Sukunimi',
    postalLocation: 'Paikkakunta',
    location: 'Sijainti',
    loggedInAs: 'Kirjautunut käyttäjänä',
    login: 'Kirjaudu',
    logout: 'Kirjaudu ulos',
    membershipCard: 'Jäsenyys',
    membershipNumber: 'Jäsennumero',
    membershipSlashCredits: 'Jäsenyys / Arvot',
    myAddress: 'Osoitteeni',
    myPage: 'Oma sivuni',
    myProfile: 'Profiilini',
    nextCreateAccount: 'Seuraava: Luo tili',
    no: 'Ei',
    noneSelected: 'Ei valittu mitään',
    noSelectedDate: 'Päivää ei valittu',
    notAllFieldsHaveBeenFilledPleaseFillAllFields:
        'Kaikki kentät eivät ole täytetty. Täytä kaikki.',
    noUserInfoFound: 'Käyttäjätietoja ei löytynyt.',
    numberOfPersons: {
        singular: 'henkilö',
        plural: 'henkilöt',
        template: '<COUNT:person:persons>',
    } as any,
    pay: 'Maksa',
    payWithCreditCard: 'Maksa luottokortilla',
    phoneNumber: 'Puhelinnumero',
    pleaseChoose: 'Valitse',
    pleaseContact: 'Ole yhteydessä',
    pleaseFillOutUserInfoInProfile: 'Täytä profiilisi tiedot.',
    pleaseLogInToBook: 'Kirjaudu sisään ostaaksesi.',
    pleaseLogInToPurchase: 'Kirjaudu sisään, niin täytämme tietosi.',
    pleaseProvideAllValueCardInformation: 'Anna kaikki arvolipputiedot.',
    pleaseProvideProperBookingInformation: 'Anna kelvolliset varauksen tiedot.',
    pleaseRegister: 'Rekisteröidy',
    postalCodeAndLocation: 'Postinumero / sijainti',
    prefix: 'Etuliite',
    privacyPolicy: 'Tietosuojakäytäntö',
    problemLoadingData: 'Virhe tietojen latauksessa',
    processing: 'Käsitellään',
    purchaseValueCard: 'Osta arvolippu',
    readMoreAbout: 'Lue lisää',
    readMoreAndBook: 'Lue lisää ja osta',
    readMoreAndBuy: 'Lue lisää ja osta',
    refillCredits: 'Täydennä arvoja',
    returnToWebsite: 'Palaa sivustolle',
    scanTicket: 'Skannaa lippu',
    signUp: 'Rekisteröidy',
    subtract: 'Vähennä',
    shoesAndHarnessAlwaysIncluded: 'Kengät ja valjas ainaincluded.',
    shoesAndHarnessNotIncluded: 'Kengät ja valjas eivät sisälly.',
    somethingWentWrongUpdatingUserInfo: 'Tietojen päivityksessä tapahtui virhe.',
    termsOfUse: {
        template: 'Käyttöehdot kohteelle <NAME>',
    } as any,
    upcomingBookings: 'Tulevat varaukset',
    updateAddress: 'Päivitä osoite',
    terminate: 'Lopeta',
    thankYouForBookingWithUs: 'Kiitos varauksestasi.',
    thePrivacyPolicy: 'Tietosuojakäytäntö',
    thankYouForShoppingWithUs: 'Kiitos ostoksistasi.',
    thisGiftcardIsEmpty: 'Tämä lahjakortti on tyhjä.',
    tHours: 't',
    totalCredits: 'Arvot yhteensä',
    totalNOK: 'Yhteensä NOK',
    updateBooking: 'Päivitä varaus',
    updateProfile: 'Päivitä profiili',
    useGiftcard: 'Käytä lahjakorttia',
    useGiftcardOrPromocode: 'Käytä lahjakorttia/promokoodia',
    validationNotANumber: 'Täytyy olla numero',
    validationMaxNumber: {
        template: 'Ei yli <NUM>',
    } as any,
    validationMinNumber: {
        template: 'Ei alle <NUM>',
    } as any,
    validForThePeriod: 'Voimassa ajanjaksolla',
    validUntil: 'Voimassa asti',
    validFrom: 'Voimassa alkaen',
    valueCard: 'Arvolippu',
    visitors: 'Vieraat',
    withoutVat: 'Ilman ALV',
    yes: 'Kyllä',
    youDontHaveAnyUpcomingBookings: 'Sinulla ei ole tulevia varauksia.',
    youDontHaveAnyValueCards: 'Sinulla ei ole arvolippuja.',
    youDontHaveAValidMembershipDoYouWantToPurchaseIt:
        'Sinulla ei ole voimassaolevaa jäsenyyttä. Ostatko yhden?',
    youMustSpecifyAValueCard: 'Sinun on annettava kelvollinen arvolippu.',
    yourReservationTimedOut: 'Varausaikasi raukesi.',
    zipcode: 'Postinumero',
    payByMembershipCard: 'Maksa jäsenkortilla',
    payWith: 'Maksa',
    deleteMyProfile: 'Poista profiilini',
    areYouSureYouWantToDeleteYourProfile: 'Haluatko varmasti poistaa profiilisi?',
    deleteYourProfileInformation: 'Olet poistamassa profiilitietojasi ... tätä ei voi peruuttaa.',
    choosePaymentOtherMethods: 'Valitse muu maksutapa',
    dontUseMembershipCardForThisBooking: 'Älä käytä jäsenkorttia tähän varaukseen',
    nameNotProvided: 'Nimi puuttuu',
    phoneNumberNotProvided: 'Puhelinnumero puuttuu',
    emailNotProvided: 'Sähköposti puuttuu',
    addressNotProvided: 'Osoite puuttuu',
    promocode: 'Promokoodi',
    show_usage_terms: 'Näytä käyttöehdot',
    hide_usage_terms: 'Piilota käyttöehdot',
    about_the_product: 'tuotteen tiedot',
    successful: 'Onnistui',
    selectProduct: 'Valitse tuote',
    withCreditCard: 'Luottokortilla',
    paymentMethod: 'Maksutapa',
    noAvailableTimeslots: 'Ei vapaita aikoja',
    orderReference: 'Tilausnumero',
    iWishToRecieveNewsletters: 'Haluan vastaanottaa uutiskirjeitä',
    mySite: 'Oma sivuni',
    pleaseConfirm: {
        template: 'Vahvista "<NAME>"',
    } as any,
    pleaseProvideNumberOfParticipants: 'Anna osallistujien määrä',
    pleaseSelectTheDateAndTimeOfYourBooking: 'Valitse varauksen päivä ja aika',
    pleaseSelectNumberOfCredits: 'Valitse arvolippujen määrä',
    pleaseSelectTypeOfCreditcard: 'Valitse luottokortin tyyppi',
    pleaseSelectAStartDate: 'Valitse aloituspäivä',
    pleaseSelectAMembershipType: 'Valitse jäsenyystyyppi',
    contactCustomerServiceToDeleteYourProfile:
        'Ota yhteyttä asiakaspalveluun poistaaksesi profiilisi',
    inclInMembership: 'Sisältää jäsenyyden',
    maxAmount: 'Max määrä',
    checkIn: 'Sisäänkirjautuminen',
    checkOut: 'Uloskirjautuminen',

    anErrorOccurredDuringPayment: 'Virhe maksun aikana',
    anErrorOccurredPleaseTryAgainByReloadingThePageErrorMessage:
        'Virhe, yritä uudelleen lataamalla sivu. Virheviesti',
    share: 'Jaa',
    copyLink: 'Kopioi linkki',
    howDoYouWantToShare: 'Kuinka haluat jakaa?',

    shoppingCart: 'Ostoskori',
    heresMyShoppingCart: 'Tässä ostoskorini',
    thereIsNotEnoughCapacityForTheItemsInThisCart:
        'Tässä korissa ei ole tarpeeksi kapasiteettia tuotteille',

    full: 'Täynnä',
    no_available_capacity_for_this_tour: 'Tälle kierrokselle ei ole vapaita paikkoja',
    no_availability_for_selected_rooms_and_guests:
        'Tämä vieraiden määrä ei ole saatavilla näille päiville — kokeile vähemmän vieraita tai muita päivämääriä.',
    one_or_more_activities_or_accommodations_dont_have_enough_capacity:
        'Yksi tai useampi aktiviteetti tai majoitus ei mahdu valituilla ehdoilla',

    pick_a_date: 'Valitse päivämäärä',
    package: 'Paketti',
    packages: 'Paketit',
    customize_activities: 'Muokkaa aktiviteetteja',
    check_in_at: 'Kirjautuminen kello',
    activity_starts_at: 'Aktiviteetti alkaa kello',
    other_times_are_available: 'Muita aikoja saatavilla',
    press_to_select_other_options: 'Paina valitaksesi muita vaihtoehtoja',
    unavailableForSelectedTime: 'Ei saatavilla valittuna aikana',
    order_status_awaiting_payment: 'Maksua odotetaan',
    order_status_payment_failed: 'Maksu epäonnistui',
    awaiting_payment_info: 'Maksua käsitellään… ei yleensä kestä muutamaa minuuttia.',
    cancel_membership: 'Peruuta jäsenyys',
    update_subscription_payment_details: 'Päivitä tilauksen maksutiedot',
    payment_failed_info: 'Maksussa ilmeni ongelma. Voit päivittää maksutiedot.',
    retry_subscription_payment: 'Yritä maksaa uudelleen',

    entrance: 'Sisäänkäynti',
    related_products: 'Liittyvät tuotteet',
    some_tickets_are_unavailable_the_selected_day:
        'Jotkut liput eivät ole saatavilla valittuna päivänä',
    company: 'Yritys',
    customer_type: 'Asiakastyyppi',
    company_name: 'Yrityksen nimi',
    org_number: 'Y-tunnus',
    pay_with_invoice: 'Maksa laskulla',
    continueWithRebooking: 'Jatka uudelleenvarauksella',
    searchAndBookAccommodations: 'Etsi ja varaa majoitus',
    selectNumberOfGuests: 'Valitse vieraiden määrä',
    checkAvailability: 'Tarkista saatavuus',
    updateAvailability: 'Päivitä saatavuus',
    you_will_have_to_switch_rooms_during_your_stay:
        'Sinun täytyy vaihtaa huonetta oleskelun aikana. Ota yhteyttä varataksesi.',
    selected: 'Valittu',
    remove: 'Poista',
    empty_cart: 'Tyhjennä ostoskori',
    aria_increase: 'Lisää',
    aria_decrease: 'Vähennä',
    promo_code_not_supported_for_gift_cards: 'Promokoodi ei ole käytettävissä lahjakorteille',
    select_products: 'Valitse tuotteet',
    change_selected_products: 'Vaihda valittuja tuotteita',
    see_available_tickets: 'Katso saatavilla olevat liput',
    waiting_list: 'Jonotuslista',
    join_waiting_list: 'Liity jonotuslistalle',
    no_waiting_list_items_found: 'Jonotuslistalle varattuja kohteita ei löytynyt korista',
    waiting_list_notification_message: 'Ilmoitamme sinulle, kun paikkoja vapautuu',

    waiting_list_what_happens_next: 'Mitä tapahtuu seuraavaksi?',
    waiting_list_next_steps:
        'Seuraamme valitsemien kohteiden saatavuutta|Saat sähköpostin, kun paikkoja vapautuu|Seuraa sähköpostissa olevaa linkkiä viimeistelläksesi varauksesi',
    product_required_for_function: {
        template: 'Tuote vaaditaan funktiolle <NAME>, vastaanotettu: <NAME>',
    } as any,
    giftcard_cannot_be_used_with_deposit_payment: 'Lahjakorttia ei voi käyttää ennakkomaksuun',
};

export default translations;
